module.exports = __webpack_public_path__ + "static/media/icon_edit_white.ce004cf0.svg";